import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { FinDokumentStavka } from './fin-dokument-stavka';

@Component({
  selector: 'yt-fin-dokument-stavka-inline-update',
  templateUrl: './fin-dokument-stavka-inline-update.component.html'
})
export class FinDokumentStavkaInlineUpdateComponent extends BaseInlineUpdateComponent<FinDokumentStavka> {
  constructor(protected inlineContainerService: InlineContainerService<FinDokumentStavka>){
    super(inlineContainerService);
  }
}
